import { useDispatch } from 'react-redux';
import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';

const useSendInsdes = () => {
  const dispatch = useDispatch();

  const sendInsdes = async (orderRef) => {
    if (!orderRef) {
      dispatch(
        setSnackBar({
          open: true,
          message: 'Reference commande manquante',
          color: 'error',
        })
      );
      return null;
    }

    try {
      let responseData = null;
      await AxiosConfig.create('post', `/orders/${orderRef}/sendInsdes`)
        .call()
        .exit((res) => (responseData = res?.data));

      dispatch(
        setSnackBar({
          open: true,
          message:
            responseData?.message ||
            `Flux EDI envoye pour ${orderRef}`,
          color: 'success',
        })
      );
      return responseData;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.errorMessage ||
        "Erreur lors de l'envoi du flux EDI";
      dispatch(
        setSnackBar({
          open: true,
          message: errorMessage,
          color: 'error',
        })
      );
      return null;
    }
  };

  return { sendInsdes };
};

export default useSendInsdes;
